(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["usparts-gewaehrleistung"] && !Shopify.designMode) return;
  try {
    /* R754 · EIN Dialog je Seite, gebaut beim ersten Klick. Ohne showModal (sehr alte Browser) bleibt der Link: Er öffnet die Datei. */
  (function () {
    if (window.__uspGw) return;
    window.__uspGw = true;
    var dlg = null;
    function baue(a) {
      dlg = document.createElement('dialog');
      dlg.className = 'usp-gw-dialog';
      dlg.setAttribute('aria-label', a.getAttribute('data-usp-gw-titel') || '');
      var flaeche = document.createElement('div');
      flaeche.className = 'usp-gw-dialog__flaeche';
      flaeche.setAttribute('data-lenis-prevent', '');
      var img = document.createElement('img');
      img.className = 'usp-gw-dialog__bild';
      img.width = 794; img.height = 1123;
      img.decoding = 'async';
      flaeche.appendChild(img);
      var fuss = document.createElement('div');
      fuss.className = 'usp-gw-dialog__fuss';
      var satz = document.createElement('span');
      var link = document.createElement('a');
      link.target = '_blank'; link.rel = 'noopener';
      satz.appendChild(document.createTextNode(''));
      satz.appendChild(link);
      var zu = document.createElement('button');
      zu.type = 'button';
      zu.className = 'usp-gw-dialog__zu';
      zu.addEventListener('click', function () { dlg.close(); });
      fuss.appendChild(satz); fuss.appendChild(zu);
      dlg.appendChild(flaeche); dlg.appendChild(fuss);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      document.body.appendChild(dlg);
    }
    /* R754b · Escape schließt ZUERST die Mitteilung. In der Warenkorb-Schublade hört theme-drawer.js am Dokument auf
       Escape und ruft preventDefault() — damit unterdrückte es das native „cancel“ unseres Dialogs, und das erste
       Escape verpuffte (Prüfer). Am Fenster in der Capture-Phase kommen wir vor jedem Dokument-Hörer dran; die
       Schublade bleibt offen, der Kunde ist wieder im Warenkorb. */
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || e.isComposing || !dlg || !dlg.open) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      dlg.close();
    }, true);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-usp-gw]') : null;
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      if (typeof HTMLDialogElement !== 'function') return;
      e.preventDefault();
      if (!dlg) baue(a);
      var img = dlg.querySelector('img');
      var quelle = a.getAttribute('data-usp-gw');
      if (img.getAttribute('src') !== quelle) img.setAttribute('src', quelle);
      img.alt = (a.getAttribute('data-usp-gw-titel') || '') + ': ' + (a.getAttribute('data-usp-gw-kurz') || '') + ' – ' + (a.getAttribute('data-usp-gw-ziel') || '');
      img.setAttribute('lang', a.getAttribute('lang') || '');
      var satz = dlg.querySelector('.usp-gw-dialog__fuss span');
      satz.firstChild.nodeValue = (a.getAttribute('data-usp-gw-mehr') || '') + ' ';
      var link = satz.querySelector('a');
      link.href = 'https://' + a.getAttribute('data-usp-gw-ziel');
      link.textContent = a.getAttribute('data-usp-gw-ziel');
      dlg.querySelector('.usp-gw-dialog__zu').textContent = a.getAttribute('data-usp-gw-zu') || '×';
      dlg.setAttribute('aria-label', a.getAttribute('data-usp-gw-titel') || '');
      /* Liegt der Auslöser in einem offenen Modal (Warenkorb-Schublade), muss der neue Dialog darüber liegen:
         showModal legt ihn in die oberste Ebene. */
      if (!dlg.open) dlg.showModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
